import { urlWithParams } from '@marketplace-web/shared/utils'

import { RegistrationStep } from './index'

export const ROUTES = {
  BASE: '/pro',
  ACCOUNT: {
    SOCIAL_LOGIN: '/',
    EMAIL_SIGNUP: '/email_signup',
    EMAIL_LOGIN: '/email_login',
    PICK_USERNAME: '/pick_username',
    FORGOTTEN_PASSWORD: '/forgotten_password',
  },
  HOME: '/',
  REGISTER: {
    BASE: '/register',
    BUSINESS_DETAILS: `/register/${RegistrationStep.BusinessDetails}`,
    BUSINESS_REPRESENTATIVE: `/register/${RegistrationStep.BusinessRepresentative}`,
    BUSINESS_ADDRESS: `/register/${RegistrationStep.BusinessAddress}`,
    BUSINESS_PROFILE: `/register/${RegistrationStep.BusinessProfile}`,
  },
  WALLET_CONVERSION: '/wallet_conversion',
  KYB_FORM: '/kyb',
  ADD_VAT: '/add_vat',
  PRO_INTEGRATIONS: {
    BASE: '/integrations',
    APPLICATION: '/integrations/application',
    TERMS_AND_CONDITIONS: '/integrations/terms-and-conditions',
  },
}

export const BUSINESS_REGISTER_PATH = `${ROUTES.BASE}${ROUTES.REGISTER.BASE}`
export const PRO_INTEGRATIONS_PATH = `${ROUTES.BASE}${ROUTES.PRO_INTEGRATIONS.BASE}`
export const PRO_INTEGRATIONS_APPLICATION_PATH = `${ROUTES.BASE}${ROUTES.PRO_INTEGRATIONS.APPLICATION}`
export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const WALLET_ACCOUNT_EDIT_URL = '/wallet/bank_account'
export const EPR_GUIDE_URL = '/help/1296'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_USE_URL = '/pro-terms-of-use'
export const PRIVATE_BETA_TERMS_OF_USE_URL = '/private-beta-terms-of-use'
export const BUSINESS_ACCOUNTS_HOMEPAGE = '/pro'
